module.exports = {

    'myAccount.settings': 'LhKLCjzaHJc',
    'myAccount.notifications.email': 'DxIfYijAWAM',
    'view.taskTable': 'XopoGUpGegM',
    'view.board': 'IEDED3jlUfg',
    'myWork': '1YdLkZaLhUo',
    'view.gantt': 'Y5qSGw2PFqg',
    'view.taskList': 'h-KY7wd2ptM'
};